import { useEffect } from 'react';
import { Spin } from '../components/Ant';
import { useAuthentication } from './authProvider';
import { useOutlookHostInfo } from '../hooks/useOutlookHostInfo';

const AuthCallback = () => {
  const { hostType, isInitialized } = useOutlookHostInfo();

  const { handleNormalRedirect, handleRedirectForMacOs } = useAuthentication();

  useEffect(() => {
    if (!isInitialized) return;

    const platform = Office.context.diagnostics.platform;
    const isLoggedIn = localStorage.getItem(`isLoggedIn`);
    if (globalThis.location.search.includes('code=') && !isLoggedIn) {
      if (platform === Office.PlatformType.Mac) {
        handleRedirectForMacOs();
      } else if (
        hostType === 'OutlookDesktopNew' ||
        hostType === 'OutlookDesktopOld' ||
        Office.context.platform === Office.PlatformType.OfficeOnline
      ) {
        Office.context.ui.messageParent(globalThis.location.search);
      } else {
        const queryString = globalThis.location.search;
        const params = new URLSearchParams(queryString);

        const authorizationCode = params.get('code');
        handleNormalRedirect(authorizationCode as string);
      }
    }
  }, [isInitialized, hostType, handleNormalRedirect, handleRedirectForMacOs]);
  return <Spin fullscreen />;
};

export default AuthCallback;
